import { convertAppNodeToCanvasTokenNode, type ProgrammaticMessageOptions } from '@air/feature-ag-ui-chat';

import { useEditCanvasStore } from '../store';
import { buildTransformMessage } from './buildTransformMessage';
import { getVideoToGifDisabledReason } from './canvas-asset-drop/getVideoToGifDisabledReason';
import { isVideoNode } from './typeGuards';

export type StartVideoToGifForVideoNodeParams = {
  nodeId: string;
  sendProgrammaticMessage: (message: string, options?: ProgrammaticMessageOptions) => Promise<void>;
};

export const startVideoToGifForVideoNode = async ({
  nodeId,
  sendProgrammaticMessage,
}: StartVideoToGifForVideoNodeParams) => {
  const appNode = useEditCanvasStore.getState().nodes.find((node) => node.id === nodeId);

  if (!isVideoNode(appNode) || getVideoToGifDisabledReason(appNode.data.duration)) {
    return;
  }

  useEditCanvasStore.getState().updateNodeData(nodeId, { isProcessing: true });

  try {
    const message = buildTransformMessage({ duration: appNode.data.duration, nodeId, type: 'videoToGif' });
    const sourceNode = convertAppNodeToCanvasTokenNode(appNode);
    await sendProgrammaticMessage(message, { actionName: 'videoToGif', sourceNode, sourceNodeId: nodeId });
  } finally {
    useEditCanvasStore.getState().updateNodeData(nodeId, { isProcessing: false });
  }
};
